import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';

import { PlaceholderDsComponent } from '@design-system/components/atoms/placeholder/placeholder.component';

@Component({
  selector: 'app-home-placeholder',
  templateUrl: './home-placeholder.component.html',
  styleUrls: ['./home-placeholder.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    PlaceholderDsComponent,
  ]
})
export class HomePlaceholderComponent {

  constructor() { }

}
